/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AiScanTarget, AiScanTarget$inboundSchema } from "./aiscantarget.js";

export type ListAiScanTargetsResult = {
  /**
   * Fingerprint of the served list; changes whenever the targets or their definitions change.
   */
  etag: string;
  /**
   * Version of the served catalog; the value agents echo as target_list_version once they receive it.
   */
  listVersion: number;
  /**
   * Every target in the organization's list, ordered by id.
   */
  targets: Array<AiScanTarget>;
};

/** @internal */
export const ListAiScanTargetsResult$inboundSchema: z.ZodMiniType<
  ListAiScanTargetsResult,
  unknown
> = z.pipe(
  z.object({
    etag: z.string(),
    list_version: z.int(),
    targets: z.array(AiScanTarget$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "list_version": "listVersion",
    });
  }),
);

export function listAiScanTargetsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAiScanTargetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAiScanTargetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAiScanTargetsResult' from JSON`,
  );
}
